"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("src/components/Box"));
var useAccordionContext_1 = require("./useAccordionContext");
var AccordionItem = function (_a) {
    var isDisabled = _a.isDisabled, index = _a.index, _b = _a.id, id = _b === void 0 ? '' : _b, children = _a.children, rest = __rest(_a, ["isDisabled", "index", "id", "children"]);
    var findExpanded = (0, useAccordionContext_1.useAccordionContext)().findExpanded;
    var isExpanded = findExpanded(index, id);
    var childrenWithProps = react_1.default.Children.map(children, function (child) { return react_1.default.cloneElement(child, {
        index: index,
        isDisabled: isDisabled,
    }); });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Box_1.default, __assign({ column: true, expanded: isExpanded, id: id }, rest), childrenWithProps)));
};
exports.default = AccordionItem;
